import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './containers/App';
import configureStore from './store';
import { unregister } from './registerServiceWorker';
import { ConfigProvider } from './config/ConfigProvider';

const store = configureStore({});

createRoot(document.getElementById('root')).render(
  <ConfigProvider>
    <Provider store={store}>
      <BrowserRouter>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </BrowserRouter>
    </Provider>
  </ConfigProvider>
);
unregister();
